import { render, staticRenderFns } from "./BlackDetail.vue?vue&type=template&id=b2a4618a&scoped=true"
import script from "./BlackDetail.vue?vue&type=script&lang=js"
export * from "./BlackDetail.vue?vue&type=script&lang=js"
import style0 from "./BlackDetail.vue?vue&type=style&index=0&id=b2a4618a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a4618a",
  null
  
)

export default component.exports